<div class="project-syncing-provider-dialog__header">
	<h1 mat-dialog-title class="project-syncing-provider-dialog__header-title">
		<ng-container *ngIf="data?.syncingProvider" i18n="Edit Syncing Provider Dialog@@projectSyncingProviderDialogEditTitle"
			>Edit External creative link</ng-container
		>
		<ng-container *ngIf="!data?.syncingProvider" i18n="Edit Syncing Provider Dialog@@projectSyncingProviderDialogAddTitle"
			>Add External creative link</ng-container
		>
	</h1>

	<mat-icon class="project-syncing-provider-dialog__header-btn" (click)="cancel()">close</mat-icon>
</div>

<div mat-dialog-content>
	<div [formGroup]="form" class="project-syncing-provider-dialog__form">
		<div class="project-syncing-provider-dialog__group mt-2">
			<span
				class="project-syncing-provider-dialog__title"
				i18n="Creative Package Title@@projectSyncingProviderDialogCreativePackageTitle"
				>Creative package</span
			>
		</div>
		<div class="package-area" [ngClass]="{ empty: !selectedCreativePackage }">
			<ng-container *ngIf="selectedCreativePackage">
				<div class="thumbnail">
					<img *ngIf="selectedCreativePackage.thumbnail?.assetPath as path" [src]="path" [alt]="selectedCreativePackage.name" />

					<button mat-flat-button color="primary" class="size-small" (click)="openPackageSelectorDialog()">
						<mat-icon inline>insert_drive_file</mat-icon>
						<span
							*ngIf="selectedCreativePackage"
							i18n="Creative Package Action Button@@projectSyncingProviderDialogChangePackageButton"
							>Change package</span
						>
						<span
							*ngIf="!selectedCreativePackage"
							i18n="Creative Package Action Button@@projectSyncingProviderDialogChoosePackageButton"
							>Choose your package</span
						>
					</button>
				</div>
				<div class="package-info p-4">
					<div class="flex-grow">
						<div class="name mt-1 mb-1">
							{{ selectedCreativePackage.name }}
						</div>
						<div
							class="description"
							i18n="Creative Package Description@@projectSyncingProviderDialogCreativePackageDescription"
						>
							Ad | {{ selectedCreativePackage.creativeUnits?.length || 0 }} resolutions
						</div>
					</div>

					<div class="tags">
						<mat-chip-list
							aria-label="Package tags"
							i18n-aria-label="Package tags@@projectSyncingProviderDialogCreativePackageTagsLabel"
							class="tags-list"
						>
							<mat-chip *ngFor="let tag of selectedCreativePackage.tags" class="tag-item">{{ tag }}</mat-chip>
						</mat-chip-list>
					</div>
					<div class="overlay"></div>
				</div>
			</ng-container>
			<div>
				<button mat-flat-button *ngIf="!selectedCreativePackage" color="primary" (click)="openPackageSelectorDialog()">
					<mat-icon inline>insert_drive_file</mat-icon>
					<ng-container i18n="Creative Package Action Button@@projectSyncingProviderDialogChoosePackageButton"
						>Choose your package</ng-container
					>
				</button>
			</div>
		</div>

		<div class="project-syncing-provider-dialog__group mt-2">
			<span class="project-syncing-provider-dialog__title" i18n="Data Source Title@@projectSyncingProviderDialogDataSourceTitle"
				>Data source</span
			>
		</div>

                <div class="project-syncing-provider-dialog__group">
                        <app-select-input
                                [parentForm]="form"
                                controlName="dataSource"
                                [options]="data.dataSources"
                                optionLabelKey="name"
                                optionValueKey="id"
                                [fullWidth]="true"
                                [formFieldCss]="'no-underline form-field dark-color project-syncing-provider-dialog__input'"
                                [showSearch]="true"
                                [searchKeys]="['id', 'name']"
                        ></app-select-input>


					<button
						mat-stroked-button
						class="mt-2"
						type="button"
						color="primary"
						(click)="manageDataSources()"
						i18n="Manage Data Sources Button@@projectSyncingProviderDialogManageDataSourcesButton"
					>
						Manage Data Sources
					</button>
                </div>

		<ng-container formGroupName="config">
			<div class="project-syncing-provider-dialog__group mt-2">
				<span
					class="project-syncing-provider-dialog__title"
					i18n="Datasource Configuration@@projectSyncingProviderDialogConfigurationTitle"
					>Configuration</span
				>
			</div>

			<div class="project-syncing-provider-dialog__group">
				<mat-checkbox
					formControlName="hideSizes"
					color="primary"
					class="p-2 size-big no-border no-disable"
					i18n="Datasource Configuration@@projectSyncingProviderDialogConfigurationHideSizesOptionLabel"
					>Control sizes via Smartsheet</mat-checkbox
				>
			</div>

			<div class="project-syncing-provider-dialog__group">
				<span
					class="project-syncing-provider-dialog__subtitle"
					i18n="Datasource Configuration@@projectSyncingProviderDialogSynchronizationTitle"
					>Synchronization</span
				>
				<mat-checkbox
					formControlName="syncActionsEnabled"
					color="primary"
					class="p-2 size-big no-border no-disable"
					(change)="syncEnable($event)"
					i18n="Datasource Configuration@@projectSyncingProviderDialogSynchronizationBiDirectional"
					>Bi-directional synchronization</mat-checkbox
				>
				<div class="project-syncing-provider-dialog__group" formGroupName="syncActions" *ngIf="syncActionsEnabled">
					<mat-checkbox
						formControlName="add"
						color="primary"
						class="p-2 pl-6 size-big no-border no-disable"
						i18n="Datasource Configuration@@projectSyncingProviderDialogSynchronizationAddItemsOptionLabel"
						>Added items</mat-checkbox
					>
					<mat-checkbox
						formControlName="update"
						color="primary"
						class="p-2 pl-6 size-big no-border no-disable"
						i18n="Datasource Configuration@@projectSyncingProviderDialogSynchronizationUpdateItemsOptionLabel"
						>Updated items</mat-checkbox
					>
					<mat-checkbox
						formControlName="delete"
						color="primary"
						class="p-2 pl-6 size-big no-border no-disable"
						i18n="Datasource Configuration@@projectSyncingProviderDialogSynchronizationDeleteItemsOptionLabel"
						>Deleted items</mat-checkbox
					>
				</div>
			</div>

			<div class="project-syncing-provider-dialog__group sizes" formGroupName="sizes" *ngIf="selectedCreativePackage">
				<span
					class="project-syncing-provider-dialog__subtitle mt-2"
					i18n="Datasource Configuration@@projectSyncingProviderDialogSizesTitle"
					>Sizes</span
				>
				<div *ngFor="let size of sizes?.controls; index as index" [formGroupName]="index" class="sizes">
					<mat-checkbox formControlName="enabled" color="primary" class="p-2 size-big no-border no-disable">
						{{ size.get('name').value }}
						<span class="size">{{ size.get('width').value }} x {{ size.get('height').value }}</span>
					</mat-checkbox>
				</div>
			</div>
		</ng-container>

		<div class="form-error-container" *ngIf="!form.valid">
			<mat-icon class="mr-1">clear</mat-icon>
			<span i18n="Error Message@@projectSyncingProviderDialogMissingRequiredField">Missing required field.</span>
		</div>
	</div>
</div>

<div mat-dialog-actions class="pt-5 pb-3">
	<button
		class="margin-left-auto project-syncing-provider-dialog__button"
		color="secondary"
		mat-button
		(click)="cancel()"
		i18n="Dialog Button@@projectSyncingProviderDialogCancelButtonLabel"
	>
		Cancel
	</button>
	<button
		mat-flat-button
		color="primary"
		[disabled]="!form.valid || isSubmitting"
		[class.loading-spinner]="isSubmitting"
		class="remove button-extra-small project-syncing-provider-dialog__button"
		(click)="submit()"
	>
		<ng-container *ngIf="data.syncingProvider" i18n="Dialog Button@@projectSyncingProviderDialogUpdateButtonLabel"
			>Update link</ng-container
		>
		<ng-container *ngIf="!data.syncingProvider" i18n="Dialog Button@@projectSyncingProviderDialogCreateButtonLabel"
			>Create link</ng-container
		>
	</button>
</div>
